/* YB cart drawer — keep the host element's `is-empty` class in sync with the cart.

   Dawn stamps `is-empty` on <cart-drawer> when the page is served with an empty
   cart. After an add, Dawn's renderContents() swaps #CartDrawer's innerHTML but
   only tries to clear `is-empty` from `.drawer__inner` — the class actually lives
   on the <cart-drawer> host, so it survives. Dawn's own rules then keep
   `.cart__contents` at display:none and the first item renders invisible while
   the header count and totals look correct. Re-syncing the class fixes it. */
(function () {
  function sync() {
    var d = document.querySelector('cart-drawer');
    if (!d) return;
    // The freshly rendered markup is the source of truth: the empty state block
    // is only emitted when the cart really is empty.
    d.classList.toggle('is-empty', !!d.querySelector('.yb-cart-empty'));
  }

  function patch() {
    var d = document.querySelector('cart-drawer');
    if (!d || d.__ybEmptySync || typeof d.renderContents !== 'function') return false;
    d.__ybEmptySync = true;

    var orig = d.renderContents.bind(d);
    d.renderContents = function (state) {
      orig(state);
      sync();
    };

    // Quantity changes and removals go through CartDrawerItems, which replaces
    // .drawer__inner directly instead of calling renderContents — watch the
    // subtree so those paths stay in sync too.
    try {
      new MutationObserver(sync).observe(d, { childList: true, subtree: true });
    } catch (e) {}

    sync();
    return true;
  }

  function boot() {
    if (patch()) return;
    // cart.js is deferred, so the custom element may not be upgraded yet.
    var tries = 0;
    var iv = setInterval(function () {
      if (patch() || ++tries > 25) clearInterval(iv);
    }, 120);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
